export default __webpack_public_path__ + "static/media/lp-sec05_bg1030.09b8356c.png";